import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AutofocusDirective } from './auto-focus.directive'
import { IsVisibleDirective } from './is-visible.directive'
import { EnterElementViewportDirective } from './enter-element-viewport.directive'
import { EnterHostViewportDirective } from './enter-host-viewport.directive'

@NgModule({
  declarations: [
    AutofocusDirective,
    IsVisibleDirective,
    EnterElementViewportDirective,
    EnterHostViewportDirective
  ],
  imports: [CommonModule],
  exports: [
    AutofocusDirective,
    IsVisibleDirective,
    EnterElementViewportDirective,
    EnterHostViewportDirective
  ]
})
export class DirectivesModule {}
